import React, { useState } from 'react';
import './ProjectViewer.css';
import ProjectViewerSidebar from '../ProjectViewerSidebar/ProjectViewerSidebar';

const ProjectViewer = ({ project, onBack }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  if (!project) {
    return (
      <div className="project-viewer-container">
        <div className="viewer-error">
          <h2>Project not found</h2>
          <button onClick={onBack}>Back to Project</button>
        </div>
      </div>
    );
  }

  return (
    <div className="project-viewer-container">
      {/* Viewer Header */}
      <div className="viewer-header">
        <button className="viewer-back-btn" onClick={onBack}>
          <i className="fas fa-arrow-left"></i>
          Back
        </button>
        
        <div className="viewer-title">
          <h1>{project.Name} - 3D Viewer</h1>
        </div>
        
        <div className="viewer-controls">
          <button className="viewer-btn">
            <i className="fas fa-expand"></i>
            Fullscreen
          </button>
          <button className="viewer-btn">
            <i className="fas fa-cog"></i>
            Settings
          </button>
        </div>
      </div>
      
      {/* 3D Viewer Content */}
      <div className="viewer-content">
        <div className="viewer-main">
          <div className="viewer-canvas">
            {/* This is where the 3D viewer would be integrated */}
            <div className="viewer-placeholder">
              <div className="placeholder-content">
                <i className="fas fa-cube"></i>
                <h3>3D Viewer</h3>
                <p>Project: {project.Name}</p>
                <p>This is where the 3D model viewer would be integrated.</p>
                <div className="viewer-info">
                  <span>WebGL-based 3D visualization</span>
                  <span>Interactive model exploration</span>
                  <span>Real-time rendering</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Sidebar Toggle Button - positioned on viewer side */}
          <button 
            className="project-viewer-sidebar-toggle"
            onClick={toggleSidebar}
            title={isSidebarCollapsed ? "Show Sidebar" : "Hide Sidebar"}
          >
            <i className={`fas ${isSidebarCollapsed ? 'fa-chevron-left' : 'fa-chevron-right'}`}></i>
          </button>
        </div>
        
        {/* Viewer Sidebar */}
        <ProjectViewerSidebar 
          project={project} 
          isCollapsed={isSidebarCollapsed} 
        />
      </div>
    </div>
  );
};

export default ProjectViewer;
